






import Vue from 'vue'
import logging from '@/utils/logging'

export default Vue.extend({
  computed: {
    messages (): string[] {
      return logging.messages
    }
  }
})
